<span>{{ cellValue }}</span>
<span class="name-cell-renderer__select-all-box">
  <a href="#" (click)="selectAll($event)">{{
    "subscriptions.select-all" | translate
  }}</a>
</span>
